import { EventService, } from '@metaos/hub-sdk';
export class AppButtonService extends EventService {
}
//# sourceMappingURL=AppButtonService.js.map